/**
 * Is dit een adres waar mail überhaupt bezorgd kan worden?
 *
 * Aanleiding (17-08-2026): een doorverwijs-reply ging naar
 * `image001.png@01dd2e36.0fea54f0` — de Content-ID van een inline
 * handtekening-afbeelding uit de klantmail. Zo'n token bevat een @ en
 * passeert elke "bevat een apenstaart"-check. De klasse: e-mail-achtige
 * tokens die geen mailadres zijn (cid:-referenties, Message-ID's,
 * iCal-UID's) hebben geen echte TLD; een bezorgbaar adres eindigt op een
 * alfabetische TLD (of een xn--punycode-TLD).
 *
 * Gedeeld door UI (DoorverwijsDialog), extractie (doorverwijs-prefill,
 * embedded-address-extractor) en het verzendpad (inbox/reply
 * sanitizeEmailHeader) — gate en uitvoerder hanteren dezelfde regel.
 */
const BEZORGBAAR_RE = /^[^\s@]+@[^\s@]+\.(?:[a-zA-Z]{2,24}|xn--[a-zA-Z0-9-]{2,})$/;

export function isBezorgbaarEmail(email: string | null | undefined): boolean {
  return BEZORGBAAR_RE.test((email || '').trim());
}
